import { LoginResponseVerifyRequiredError } from '../transport/types/LoginResponseVerifyRequiredError';

export const isLoginResponseVerifyRequiredError = (
    _responseData: unknown
): _responseData is LoginResponseVerifyRequiredError => {
    const responseData = _responseData as any;
    return 'data' in responseData && responseData.data && 'user_id' in responseData.data;
};
